import { ReactNode } from 'react';
import { LockClosedIcon } from '@heroicons/react/24/outline';
import './RestrictedAccess.css';
import Enrichment from '@/modules/enrichment/Enrichment';
import AdvancedSearchUtiles from '@/components/AdvancedSearch/AdvancedSearchUtiles';

interface RestrictedAccessProps {
  feature: 'advancedSearch' | 'enrichment';
  children?: ReactNode;
}

const RestrictedAccess: React.FC<RestrictedAccessProps> = ({ feature, children }) => {
  return (
    <div className="restricted-wrapper">
      <div className="restricted-blurred">
        {feature === 'advancedSearch' ? <AdvancedSearchUtiles /> : <Enrichment />}
      </div>

      <div className="restricted-overlay">
        <div className="restricted-box">
          <LockClosedIcon className="mb-2 w-10 h-10" color="#D02591" />
          <h6>This feature is available only for authenticated users</h6>
          <h6>
            See all the{' '}
            <a href="/plans" style={{ color: '#D02591' }}>
              plans here
            </a>
            .
          </h6>
        </div>
      </div>
    </div>
  );
};

export default RestrictedAccess;
